import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadNotificationTypesFailed,
  loadNotificationTypesSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadNotificationTypes(action) {
  try {
    const url = `${BACKEND_URL}/proxy/backend/api/v1/enums/user-notification-template-type`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse?.json();
    if (dataResponse?.status === OK) {
      yield put(loadNotificationTypesSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadNotificationTypesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadNotificationTypesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
